@if (!isPublicModeActive()) {
  <layout-operations-in-progress />
  <layout-ai-assistant-button />
  <user-online-list />
  <user-logged-info />
}
<sim-fullscreen />
